var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssignEventMenuCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93936 8.00002L3.22705 4.28771L4.28771 3.22705L8.00002 6.93936L11.7123 3.22705L12.773 4.28771L9.06068 8.00002L12.773 11.7123L11.7123 12.773L8.00002 9.06068L4.28771 12.773L3.22705 11.7123L6.93936 8.00002Z",
    fill: "#171F46"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignEventMenuCloseBtn);
export default __webpack_public_path__ + "static/media/AssignEventMenuCloseBtn.d8d5b01b0a449aa984dbb9edc1119049.svg";
export { ForwardRef as ReactComponent };